var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:" pl-2",attrs:{"text":""}},on),[_vm._v("\n        Admin\n      ")])]}}])},[_c('v-list',_vm._l((_vm.admin),function(item,index){return _c('v-list-item',{key:index,attrs:{"to":item.link}},[_c('v-list-item-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }